<template>
  <div style="width: 100%">
    <v-container>
      <v-row v-if="loadingPage" class="d-flex justify-center">
        <custom-loading></custom-loading>
      </v-row>
      <v-row v-else>
        <autoservicio-process v-for="(process, idx) in processes" 
          :key="idx"
          :id="'autoservicioListProcesses' + idx"
          :process="process"
        >
        </autoservicio-process>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import AutoservicioProcess from './autoservicio-process.vue'
import CustomLoading from '../../custom-loading.vue'
import ShowReport from '../../../routes/show-report.vue'

export default {
  name: 'autoservicio-list-processes',
  data () {
    return {
      loadingPage: true,
      processes: []
    }
  },
  components: {
    AutoservicioProcess,
    CustomLoading,
    ShowReport
  },
  props: {
    groupID: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  methods: {
    getProcesses () {
      axios.post(uris.URL_AUTOSERVICIO_GET_PROCESSES, {
        groupID: this.groupID
      })
        .then((response) => {
          this.processes = response.data
        })
        .catch((err) => {
          console.warn('No se ha podido obtener data del autoservicio', err)
        })
        .finally(() => {
          this.loadingPage = false
        })
    }
  },
  computed: {
  },
  mounted () {
    this.getProcesses()
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/autoservicios/processes/autoservicio-list-processes.vue